import React from "react";
import Alert from "@mui/material/Alert";
import { NoItemsFound } from "../publisher/NoItemsFound";

export { PublisherListEntry2 } from "../publishers/ListItem";

export const NoPublisherInterest = () => (
  <NoItemsFound>
    <Alert severity="info">
      Track your interactions with each publisher. Start with a shortlist and then update each publisher after you've
      contacted them. Use in the in-built reminder system to know when it's time to reach out for an update.
    </Alert>
  </NoItemsFound>
);
